import React, { useEffect, useState } from "react";
import { BsDownload } from 'react-icons/bs'
import { AiOutlineClose } from 'react-icons/ai'
const InstallPWA = () => {
    const [supportsPWA, setSupportsPWA] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);

    useEffect(() => {
        const handler = e => {
            e.preventDefault();
            console.log("we are being triggered :D");
            setSupportsPWA(true);
            setPromptInstall(e);
        };
        window.addEventListener("beforeinstallprompt", handler);

        return () => window.removeEventListener("transitionend", handler);
    }, []);

    const onClick = evt => {
        evt.preventDefault();
        if (!promptInstall) {
            return;
        }
        promptInstall.prompt();
    };
    if (!supportsPWA) {
        return <></>;
    }
    return (
        <div style={{ zIndex: "1010", position: "fixed", top: "50%", borderRadius: "0 10px 10px 0" }}>
            <div style={{ position: "relative" }}>
                <button
                    className="link-button btn btn-primary"
                    id="setup_button"
                    aria-label="Install app"
                    title="Install app"
                    onClick={onClick}
                    style={{ zIndex: "1010", position: "fixed", top: "50%", borderRadius: "0 10px 10px 0" }}
                >
                    <span>Install</span>
                    <BsDownload fontSize={2} style={{ margin: "0 0 0.2rem 0.7rem", fontSize: "1.3rem", fontWeight: 800 }} />
                </button>
                <AiOutlineClose id="close_pwa" size={2} onClick={()=>setSupportsPWA(false)}/>
            </div>
        </div>
    );
};
export default InstallPWA;